@if (hasResults) {
  <div>
    @if (invalidResults.length > 0) {
      <div>
        <span>There was an error with your input.</span>
      </div>
    }
    <div>
      <p>
        <strong>Total Records Validated</strong>: {{totalCount}}
      </p>
      <p>
        <strong>Number of Valid Records</strong>: {{validResults.length}}
      </p>
      <p>
        <strong>Number of Invalid Records</strong>: {{invalidResults.length}}
      </p>
      @if (invalidResults.length > 0) {
        <div>
          <p class="divider">
            <strong>Invalid Record IDs</strong>:
          </p>
          <div class="alert alert-dark" role="status">
            @for (invalidResult of invalidResults; track invalidResult) {
              <div>
                {{invalidResult.recordID === 0 ? invalidResult.title : invalidResult.recordID}}
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}